import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(
  ({ theme }) =>
    ({ bgColor, stylee }) => ({
      ...stylee,
      background: bgColor
        ? bgColor
        : "linear-gradient(90deg, #00A44A 0%, #047C3A 100%)",
      color: "#FFF",
      fontFamily: "Open Sans",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      display: "flex",
      width: "157px",
      height: "44px",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      letterSpacing: "0.6px",
      padding: "13px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderRadius: "8px",
      textTransform: "none",
      flexShrink: 0,
      transition: "filter 0.3s ease-in-out",
      ":hover": {
        backgroundColor: bgColor
          ? bgColor
          : "linear-gradient(90deg, #00A44A 0%, #047C3A 100%)",
        color: "white",
        opacity: 0.9, // Slightly more transparent
        filter: "brightness(1.05)", // Slightly lighter
      },
    })
);
